var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useState } from 'react';
import { Grid, Hidden } from '@material-ui/core';
import { Toggle } from '@one-thd/sui-atomic-components';
import { ArrowBack, ArrowForward } from '@one-thd/sui-icons';
import { RenderSpendStatus, RenderSlideContainer, handleSlideTransition, PreviousSlideClass, } from '../../../../commons/PerkProgressSpendCommons';
import { RenderLeftMobileIcon, RenderRightMobileIcon, RenderlMobileProgressCircle, } from '../PerkProgressSpendNavigation';
import { InfoPerksContext, PerkProgressContext, } from '../../../../../../../contexts';
import { clickCta } from '../../../../../../../utils/analytics';
var userManagementAnalytics = {
    pushMyAccountButtonEvent: function (str) { return clickCta(str); },
};
export var ProXtraMobileAnnualization = function (props) {
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var _a = React.useContext(PerkProgressContext), plccSwitch = _a.plccSwitch, filterDataFromContext = _a.filterData, currentDataIndex = _a.currentDataIndex, initialCurrentDataIndex = _a.initialCurrentDataIndex, preYearPerk = _a.preYearPerk, detailsPlcc = _a.detailsPlcc, setCurrentDataIndex = _a.setCurrentDataIndex, prevDataIndex = _a.prevDataIndex, setPrevDataIndex = _a.setPrevDataIndex, showUnlockAnimation = _a.showUnlockAnimation, setShowUnlockAnimation = _a.setShowUnlockAnimation, controlToggle = _a.controlToggle, setControlToggle = _a.setControlToggle, slideClass = _a.slideClass, setSlideClass = _a.setSlideClass, filterData = _a.filterData, setFilterData = _a.setFilterData;
    var _b = useState(false), currentYearClick = _b[0], setCurrentYearClick = _b[1];
    var _c = useState(true), previoustYearClick = _c[0], setPrevioustYearClick = _c[1];
    var _d = useState(false), currentClick = _d[0], setCurrentClick = _d[1];
    useEffect(function () {
        sessionStorage.setItem('showUnlockAnimation', JSON.stringify(showUnlockAnimation));
    }, [showUnlockAnimation]);
    var handleLeftClick = function () {
        var _a;
        if (currentDataIndex > 0) {
            var animateTiers = __spreadArray([], showUnlockAnimation, true);
            if (animateTiers[currentDataIndex] &&
                ((_a = filterData[currentDataIndex]) === null || _a === void 0 ? void 0 : _a.tierPerks[0].perkStatus) === 'UNCLAIMED') {
                animateTiers[currentDataIndex] = false;
                setShowUnlockAnimation(animateTiers);
            }
            handleSlideTransition('prev', setSlideClass);
            var currentDataNavigation = currentDataIndex - 1;
            setPrevDataIndex(currentDataIndex);
            setCurrentDataIndex(currentDataNavigation);
            userManagementAnalytics.pushMyAccountButtonEvent("perks: progress tracker");
        }
    };
    var handleRightClick = function () {
        var _a, _b, _c;
        if (currentDataIndex < filterData.length - 1) {
            var animateTiers = __spreadArray([], showUnlockAnimation, true);
            if (animateTiers[currentDataIndex] &&
                ((_c = (_b = (_a = filterData[currentDataIndex]) === null || _a === void 0 ? void 0 : _a.tierPerks) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.perkStatus) === 'UNCLAIMED') {
                animateTiers[currentDataIndex] = false;
                setShowUnlockAnimation(animateTiers);
            }
            handleSlideTransition('next', setSlideClass);
            var currentDataNavigation = currentDataIndex + 1;
            setPrevDataIndex(currentDataIndex);
            setCurrentDataIndex(currentDataNavigation);
            userManagementAnalytics.pushMyAccountButtonEvent("perks: progress tracker");
        }
    };
    var handleCurrentClick = function () {
        setFilterData(filterDataFromContext);
        setCurrentClick(true);
        setPrevioustYearClick(false);
        setCurrentYearClick(true);
        setCurrentDataIndex(initialCurrentDataIndex);
        setPrevDataIndex(initialCurrentDataIndex);
        setSlideClass('initial-tier');
    };
    var handlePreYearClick = function () {
        var year = new Date().getFullYear();
        var preYearTabAll = preYearPerk.filter(function (perk) { return perk.yearEarned === year - 1; });
        var preYearTab = preYearTabAll.filter(function (perk) { return perk.perkStatus === 'UNCLAIMED'; });
        setFilterData(preYearTab);
        setPrevioustYearClick(true);
        setCurrentYearClick(false);
        setCurrentDataIndex(0);
        setPrevDataIndex(0);
        setCurrentClick(false);
        setSlideClass('initial-tier');
    };
    var choosePerk = currentDataIndex > initialCurrentDataIndex;
    var renderlMobileProgressCircle = function (tempData) {
        var showUnlockAnimateTier = showUnlockAnimation[currentDataIndex];
        return (React.createElement(RenderlMobileProgressCircle, { data: tempData, PerkInfo: perksInfo, stateData: perksInfo, controlToggle: controlToggle, detailsPlcc: detailsPlcc, plccSwitch: plccSwitch, showUnlockAnimateTier: showUnlockAnimateTier }));
    };
    var renderSpendStatusMobile = function (tempData) {
        return (React.createElement(RenderSpendStatus, { PerkInfo: perksInfo, data: tempData, showUnlockAnimateTier: showUnlockAnimation }));
    };
    var renderLeftMobileIcon = function (prevData, tempData) {
        var mobileClass = slideClass;
        var prev = slideClass === PreviousSlideClass;
        var previousPerk = prevDataIndex > 0 ? (React.createElement(RenderLeftMobileIcon, { data: prevData, stateData: perksInfo, choosePerk: function () { return choosePerk; } })) : ('');
        var currentPerk = currentDataIndex > 0 ? (React.createElement(RenderLeftMobileIcon, { data: tempData, stateData: perksInfo, choosePerk: function () { return choosePerk; } })) : ('');
        if (prev) {
            return (React.createElement(RenderSlideContainer, { itemClassString: mobileClass, isPrev: prev },
                currentPerk,
                previousPerk));
        }
        return (React.createElement(RenderSlideContainer, { itemClassString: mobileClass, isPrev: prev },
            prevDataIndex !== currentDataIndex && previousPerk,
            currentPerk));
    };
    var renderRightMobileIcon = function (nextData, tempData) {
        var mobileClass = slideClass;
        var prev = slideClass === PreviousSlideClass;
        var previousPerk = prevDataIndex < filterData.length - 1 ? (React.createElement(RenderRightMobileIcon, { data: nextData, stateData: perksInfo, filterData: filterData, currentDataIndex: prevDataIndex })) : ('');
        var currentPerk = currentDataIndex < filterData.length - 1 ? (React.createElement(RenderRightMobileIcon, { data: tempData, stateData: perksInfo, filterData: filterData, currentDataIndex: currentDataIndex })) : ('');
        if (prev) {
            return (React.createElement(RenderSlideContainer, { itemClassString: mobileClass, isPrev: prev },
                currentPerk,
                prevDataIndex !== currentDataIndex && previousPerk));
        }
        return (React.createElement(RenderSlideContainer, { itemClassString: mobileClass, isPrev: prev },
            prevDataIndex !== currentDataIndex && previousPerk,
            currentPerk));
    };
    var renderMobileNavigation = function () {
        var currentIndexBack = filterData[currentDataIndex - 1];
        var currentIndexNext = filterData[currentDataIndex + 1];
        var currentDataSelected = filterData[currentDataIndex];
        var prevIndexBack = currentDataIndex === prevDataIndex
            ? currentIndexBack
            : filterData[prevDataIndex - 1];
        var prevIndexNext = currentDataIndex === prevDataIndex
            ? currentIndexNext
            : filterData[prevDataIndex + 1];
        var mobileArrowLeft = "pps-mobileArrow ".concat(currentDataIndex === 0
            ? 'pps-mobileLeftArrowDisable'
            : 'pps-mobileLeftArrow');
        var mobileArrowRight = "pps-mobileArrow ".concat(currentDataIndex === filterData.length - 1
            ? 'pps-mobileRightArrowDisable'
            : 'pps-mobileRightArrow');
        return (React.createElement(Grid, { container: true },
            React.createElement(Grid, { className: "processMobile" },
                React.createElement(RenderYearMobileButton, null),
                renderSpendStatusMobile({ item: currentDataSelected }),
                React.createElement(Grid, { className: "mobileProcessTimeline" },
                    React.createElement("div", { className: "stepSeporator-glow sS-g_left" }),
                    React.createElement(Grid, { className: "stepSeperator" }),
                    React.createElement("div", { className: "stepSeporator-glow sS-g_right" }),
                    React.createElement(Grid, { container: true },
                        React.createElement(Grid, { item: true, xs: 3, sm: 3, md: 3 },
                            renderLeftMobileIcon({ item: prevIndexBack }, { item: currentIndexBack }),
                            React.createElement("div", { className: "sui-relative" },
                                React.createElement("button", { type: "button", disabled: currentDataIndex === 0, onClick: handleLeftClick, className: mobileArrowLeft },
                                    React.createElement(ArrowBack, { color: "current", size: "small" })))),
                        React.createElement(Grid, { item: true, xs: 6, sm: 6, md: 6 }, renderlMobileProgressCircle({ item: currentDataSelected })),
                        React.createElement(Grid, { item: true, xs: 3, sm: 3, md: 3 },
                            renderRightMobileIcon({ item: prevIndexNext }, { item: currentIndexNext }),
                            React.createElement("div", { className: "sui-relative" },
                                React.createElement("button", { type: "button", disabled: currentDataIndex === filterData.length - 1, onClick: handleRightClick, className: mobileArrowRight },
                                    React.createElement(ArrowForward, { color: "current", size: "small" })))))))));
    };
    var RenderYearMobileButton = function () {
        var year = new Date().getFullYear();
        var preYearTabAll = preYearPerk.filter(function (perk) { return perk.yearEarned === year - 1; });
        var preYearTab = preYearTabAll.filter(function (perk) { return perk.perkStatus === 'UNCLAIMED'; });
        useEffect(function () {
            if (preYearTab.length === 0 && !currentClick) {
                handleCurrentClick();
            }
        }, []);
        return preYearTab.length > 0 ? (React.createElement(Grid, { container: true, className: preYearTab.length > 0
                ? 'Annualization_mobile__yearMobBox'
                : 'Annualization_mobile__yearCBox' },
            preYearTab.length > 0 && (React.createElement(Grid, { item: true, className: previoustYearClick
                    ? 'Annualization_mobile__yearPrevioustButton'
                    : ' Annualization_mobile__yearCurrentButton', onClick: handlePreYearClick },
                year - 1,
                ' ',
                React.createElement("span", { className: "Annualization_mobile__dotCircle" }, preYearTab.length))),
            preYearTab.length > 0 && (React.createElement(Grid, { item: true, className: currentYearClick
                    ? 'Annualization_mobile__yearPrevioustButton'
                    : ' Annualization_mobile__yearCurrentButton', onClick: handleCurrentClick }, "".concat(year, " "))))) : (React.createElement(React.Fragment, null));
    };
    var RenderPerkProgressall = function () { return (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(Grid, { container: true, justifyContent: "space-between", direction: "column" },
            React.createElement(Hidden, { lgUp: true }, renderMobileNavigation())))); };
    var toggle = function () {
        setControlToggle(!controlToggle);
        userManagementAnalytics.pushMyAccountButtonEvent('perks: pxcc enrolled: 4x toggle');
    };
    var RenderCardPayment = function () {
        var pxccCounter = perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.activePxccFactor;
        return (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement("div", { className: "perkProgressSpend__cardPaymentbox" },
                React.createElement("div", { className: "cardPaymentbox-container" },
                    React.createElement("span", { className: (controlToggle
                            ? 'perkProgressSpend__cardLabel sui-font-bold'
                            : '') + ' cardPaymentbox-leftText' },
                        "With",
                        ' ',
                        React.createElement("span", { className: "perkProgressSpend__modelCircle" },
                            pxccCounter,
                            "X"),
                        ' ',
                        "Card"),
                    React.createElement("div", { className: "toggle-controlToggle" },
                        React.createElement(Toggle, { checked: controlToggle, onChange: toggle, inputAttributes: { 'aria-label': 'controlled' } })),
                    React.createElement("span", { className: "" }, controlToggle ? ('With Other Payments') : (React.createElement("b", null, "With Other Payments")))))));
    };
    var RenderMobileToggle = function () {
        var currentDataSelected = filterData[currentDataIndex];
        var earnedTier = !currentDataSelected.earned;
        var currentTier = earnedTier && perksInfo.currentTierId === currentDataSelected.tierId;
        var futureTier = earnedTier && perksInfo.nextTierId === currentDataSelected.tierId;
        return (React.createElement(Grid, { container: true }, plccSwitch && (currentTier || futureTier) && React.createElement(RenderCardPayment, null)));
    };
    return (React.createElement(Grid, { container: true },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(RenderPerkProgressall, null),
            React.createElement(RenderMobileToggle, null))));
};
